import { render, staticRenderFns } from "./CameraView.vue?vue&type=template&id=20a0f56e&"
import script from "./CameraView.vue?vue&type=script&lang=ts&"
export * from "./CameraView.vue?vue&type=script&lang=ts&"
import style0 from "./CameraView.vue?vue&type=style&index=0&id=20a0f56e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports